import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

export const downloadStorageFile = async (storagePath: string, filenameBase: string) => {
  let blobUrl: string | null = null;

  try {
    const storageRef = ref(storage, storagePath);
    const downloadUrl = await getDownloadURL(storageRef);

    const extension = storagePath.split('.').pop() || 'pdf';
    const response = await fetch(downloadUrl);
    const blob = await response.blob();
    blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = `${filenameBase}.${extension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } finally {
    if (blobUrl) {
      window.URL.revokeObjectURL(blobUrl);
    }
  }
};

